import { COLORS, FONTS } from '../../../constants';

// eslint-disable-next-line no-unused-vars
const styles = theme => ({
  textLabel: {
    fontFamily: FONTS.PRIMARY,
    textTransform: 'uppercase',
    color: COLORS.GREY_DARKER,
    fontSize: '0.75rem',
    fontWeight: 600,
  },
  textValue: {
    fontFamily: FONTS.PRIMARY,
    fontWeight: 300,
    fontSize: '1rem',
    color: COLORS.GREY_DARK,
    padding: '6px 0 7px',
    wordWrap: 'break-word',
    whiteSpace: 'pre-line',
  },
  textWrapper: {
    marginBottom: '10px',
  },
});

export default styles;
